export const toastItems = [
  {
    name: "Subtype 1",
    description: "Large-artery atherosclerosis (embolus/thrombosis)",
    value: "1",
    interpretation: ""
  },
  {
    name: "Subtype 2",
    description: "Small-vessel occlusion (lacune)",
    value: "2",
    interpretation: ""
  },
  {
    name: "Subtype 3",
    description: "Cardioembolism (high-risk/medium-risk)",
    value: "3",
    interpretation: ""
  },
  {
    name: "Subtype 4",
    description: "Stroke of other determined aetiology",
    value: "4",
    interpretation: ""
  },
  {
    name: "Subtype 5a",
    description: "Stroke of undetermined aetiology: Two or more causes identified",
    value: "5a",
    interpretation: ""
  },
  {
    name: "Stage 5b",
    description: "Stroke of undetermined aetiology: Negative evaluation",
    value: "5b",
    interpretation: ""
  },
  {
    name: "Stage 5c",
    description: "Stroke of undetermined aetiology: Incomplete evaluation",
    value: "5c",
    interpretation: ""
  }
]